export const PAYMENT_GATEWAYS = {
  DECIDIR: 'decidir',
  FIRST_DATA: 'first_data'
};
